<template>
  <div class="blocks">
    <div class="top">监控</div>
    <div class="blossomVideo">     
      <div class="block">
        <el-carousel trigger="click" height="180px"   arrow="never" :autoplay="msg">
          <el-carousel-item v-for="item in videos" :key="item.id" @click="gainid(item.id)">
            <div class="bgColor" style="height:30px;width:100%;position:absolute;top:0;left:0;background: #fff;z-index:9999"></div>
            <video style="position:absolute;top:-30px;width:100%;height:140%" :src="item.url" loop autoplay  muted></video>
            <!-- <img height="200" width="200" :src="item.url" alt=""> -->
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
//这是轮播video组件
import { TweenLite } from 'gsap'
export default {
  name: "echarts01",
  props :{
      vediourl:{
          type:Array
      }
  },
  data() {
    return {
        msg:true,
        videos: [
        {
          id: 1,
          url: require('@/assets/viedeo/联通.mp4')
        },
        {
          id: 2,
          url: require('@/assets/viedeo/数字冰雹安防系统.mp4')
        },
        
      ]
    };
  },
  created() {
      this.gainid()
  },
  methods:{
      gainid(id) {
          console.log(id)
      }
  }
};
</script>
<style  scoped>
.blocks {
  width: 318px;
  height: 222px;
  background: url("../../assets/img/title-bg.png") no-repeat;
  position: relative;
  /* background: #fff; */
  border-radius: 8px;
}
.top {
  position: absolute;
  left: 85px;
  top: -12px;
  width: 150px;
  height: 32px;
  color: #776125;
  text-align: center;
  line-height: 32px;
  background-image: linear-gradient(to right,#f8f1d5, #ffffff);
  border-radius: 8px;
}
.blossomVideo {
  width: 300px;
  height: 180px;
  position: absolute;
  top: 18px;
  left: 9px;
  border-radius: 6px;
}
/* img {
    height: 200px;
    width: 200px
} */
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts01.vue